import { getActionTypeFromInstance } from '@ngxs/store';
import { Logout } from '../actions/auth.actions';
import { AtomSessionService } from '../../services/atom-session.service';
import { environment } from '@trovata/environments/environment';

export function logoutPlugin(state, action, next) {
	if (getActionTypeFromInstance(action) === Logout.type) {
		// Must run before storage is cleared: it reads the ATOM-session marker and the token.
		AtomSessionService.endSession(environment.atomApiUrl);
		const isPartnerLogin: string = localStorage.getItem('isPartnerLogin');
		state = {};
		localStorage.clear();
		sessionStorage.clear();
		if (isPartnerLogin) {
			localStorage.setItem('isPartnerLogin', isPartnerLogin);
		}
	}

	return next(state, action);
}
